// screens/PictorialScreen.jsx
import React from "react";
import Pictorial from "../components/Pictorial";

const PictorialScreen = () => {
  return (
    <main>
      <Pictorial />
    </main>
  );
};

export default PictorialScreen;